import { createSlice } from "@reduxjs/toolkit";
import type { ContactsPageState } from "../types";
import { reducers } from "./reducers";

const initialState: ContactsPageState = {
  currentPerson: null,
  contactsIsEdit: false,
  updateIsLoading: false,
  formIsValidating: false,
  formIsValid: true,
  groupFilter: null,
  nameFilter: null,
  titleFilter: null,
  sorter: null,
  swipedPerson: null,
};

export const contactsPageSlice = createSlice({
  name: "contactsPage",
  initialState,
  reducers: reducers,
});

export const {
  setUpdateIsLoading,
  setCurrentPerson,
  setContactsIsEdit,
  setFormIsValid,
  setFormIsValidating,
  setGroupFilter,
  setNameFilter,
  setTitleFilter,
  setSorter,
  setSwipedPerson,
} = contactsPageSlice.actions;
